module.exports = __webpack_public_path__ + "img/tmb.bf73fdbb.png";